import React from "react"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Button from "../../../../shared/components/atoms/button/button"
import ImageBackground from "../../../../assets/images/performance/background-image-modal.webp"
import ImageBackgroundMovil from "../../../../assets/images/performance/background-image-modal-movil.webp"
import decorationMobile from "../../../../assets/images/muestreo/decoration-mobile.svg"

const StepOne = props => {
  let {
    details,
    listItems,
    params,
    randomKey,
    homeLink,
    urlTerminosCondiciones,
    footerInfo,
    tokenID,
    setActualStep,
    actualStep,
    SAMPLE_STEP_KEY,
    mobile,
    ACTIVITY_ID_MUESTREO,
    ColorFinalText
  } = props

  let imageProduct = []

  return (
    <div className="container">

      <style jsx>
        {`
        .color-final-text:last-child {
          color: ${ColorFinalText} !important;
        }
        `}
      </style>


      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-left rounded-top-left-no-mov hidden-mov-large background-color-primary" />
      ) : null}

      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-top-mov background-color-primary " />
      ) : null}

      <div
        className={
          "details container-step-1 rounded-top-no-mov activity-modal-style " +
          (["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO)
            ? "muestra-gratis-antibacterial container-step-background"
            : "muestreo-normal")
        }
      >
        {(details = []) &&
          (listItems = []) &&
          (imageProduct = []) &&
          documentToReactComponents(params.contenidoDetalleMuestreo.json, {
            renderNode: {
              [BLOCKS.EMBEDDED_ASSET]: node => {
                imageProduct.push(
                  <img
                    className={
                      "image-step-two " +
                      (ACTIVITY_ID_MUESTREO == "48"
                        ? "image-muestreo-special"
                        : "image-muestreo")
                    }
                    src={node.data.target.fields.file[process.env.LOCALE].url}
                  />
                )
              },
              [BLOCKS.HEADING_1]: (node, children) => {
                details.push(
                  <div>
                    {(mobile && ACTIVITY_ID_MUESTREO == "91") ||
                      ACTIVITY_ID_MUESTREO == "92" ? null : (
                      <h1
                        key={randomKey}
                        className={
                          "text-color-secondary text-center-mov " +
                          (ACTIVITY_ID_MUESTREO == "48"
                            ? "muestreo-special"
                            : "muestreo-normal")
                        }
                      >
                        {children}
                      </h1>
                    )}
                  </div>
                )
              },
              [BLOCKS.HEADING_2]: (node, children) => {
                details.push(
                  <div>
                    {mobile &&
                      ACTIVITY_ID_MUESTREO == "91" &&
                      ACTIVITY_ID_MUESTREO == "92" ? (
                      <div className="image-product-mobile">{imageProduct}</div>
                    ) : null}

                    {/*<h2 key={randomKey} className="text-color-tertiary">*/}
                    <h2
                      key={randomKey}
                      className={`text-center-mov text-subtitle ${["141", "143", "192", "194"].includes(
                        ACTIVITY_ID_MUESTREO
                      )
                        ? "text-color-primary"
                        : "text-color-tertiary"
                        }`}
                    >
                      {children}
                    </h2>

                    {mobile &&
                      ACTIVITY_ID_MUESTREO != "48" &&
                      ACTIVITY_ID_MUESTREO != "91" &&
                      ACTIVITY_ID_MUESTREO != "92" ? (
                      <div className="image-product-mobile">{imageProduct}</div>
                    ) : null}
                  </div>
                )
              },
              [BLOCKS.OL_LIST]: (node, children) => {
                details.push(<ol key={randomKey}>{listItems}</ol>)
              },
              [BLOCKS.LIST_ITEM]: (node, children) => {
                listItems.push(
                  <li key={randomKey} className={"text-color-primary color-final-text"}>
                    {documentToReactComponents(node, {
                      renderNode: {
                        [BLOCKS.PARAGRAPH]: (node, children) => (
                          <p
                            className={
                              ACTIVITY_ID_MUESTREO == "91" ||
                                ACTIVITY_ID_MUESTREO == "92"
                                ? "f-text-muestra-gratis-antibacterial"
                                : ["192", "194"].includes(ACTIVITY_ID_MUESTREO)
                                  ? "f-text-muestra-gratis-sensitive"
                                  : ""
                            }
                            key={randomKey}
                          >
                            {children}
                          </p>
                        ),
                        [BLOCKS.LIST_ITEM]: (node, children) => children,
                      },
                    })}
                  </li>
                )
              },
            },
          })}
        {!mobile
          ? imageProduct
          : ACTIVITY_ID_MUESTREO == "48"
            ? imageProduct
            : null}
        <div
          className={
            "details-step-two " +
            (ACTIVITY_ID_MUESTREO == "48"
              ? "muestreo-special"
              : "muestreo-normal")
          }
        >
          {details}
          <a
            href={homeLink + urlTerminosCondiciones}
            className={
              "f-left-redirect-footer" +
              (ACTIVITY_ID_MUESTREO == "91" || ACTIVITY_ID_MUESTREO == "92"
                ? " text-color-white"
                : " text-color-primary")
            }
          >
            {footerInfo.terminosYCondiciones}
          </a>
          <Button
            // className="button background-color-primary"
            className={`button ${["141", "143"].includes(ACTIVITY_ID_MUESTREO)
              ? "background-color-quaternary"
              : "background-color-primary-button"
              }`}
            title={
              ["141"].includes(ACTIVITY_ID_MUESTREO)
                ? "Quiero mi muestra gratis"
                : "¡Participa ahora!"
            }
            onClick={e => {
              e.preventDefault()
              if (tokenID) {
                //No hay redencion de puntos
                if (["141"].includes(ACTIVITY_ID_MUESTREO)) {
                  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"))
                  const updateSampling = JSON.parse(
                    localStorage.getItem("UPDATE_DATA_SAMPLE_PRODUCT")
                  )
                  let isReadySample =
                    userInfo &&
                    updateSampling &&
                    updateSampling.some(item => {
                      return item.email === userInfo.email &&  item.activityId === ACTIVITY_ID_MUESTREO
                    })


                  if (isReadySample) {
                    setActualStep(actualStep + 2)
                  } else {
                    setActualStep(5)
                  }
                } else {
                  setActualStep(actualStep + 1)
                }
              } else {
                sessionStorage.setItem("NEXT_PAGE", window.location.pathname)
                sessionStorage.setItem(SAMPLE_STEP_KEY, 1)
                window.location.href = "/login"
              }
            }}
          />
        </div>
      </div>

      {
        !["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
          <div className="decoration-right rounded-top-right-no-mov hidden-mov-large background-color-primary" />
        ) : null
      }
    </div >
  )
}

export default StepOne
